import { render, staticRenderFns } from "./LogoutLayout.vue?vue&type=template&id=18e6388e"
import script from "./LogoutLayout.vue?vue&type=script&lang=js"
export * from "./LogoutLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_css-loader@6.11.0_webpack@5.98.0__lodash@4._0ede07508368b0c10a5f63bb0b6a47bb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports